// extracted by mini-css-extract-plugin
export var header = "_vy-1";
export var maskBottom = "_vy-6";
export var maskMiddle = "_vy-7";
export var maskTop = "_vy-5";
export var root = "_vy-0";
export var scrollDownButton = "_vy-3";
export var scrollDownButtonHidden = "_vy-4";
export var viewport = "_vy-2";